module.exports = __webpack_public_path__ + "static/media/synagogue.bc949d06.svg";